import { styled } from '@material-ui/core'

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  minHeight: '100%',
  backgroundColor: theme.palette.secondary.light,
  overflowX: 'scroll',
  flexWrap: 'wrap',
}))

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%',
  minHeight: '100%',
  boxSizing: 'border-box',
  padding: theme.spacing(4, 5, 4, 13.5),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(4, 2.3, 4, 9.8),
  },
}))

export const BannerContainer = styled('div')(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(10.5, 5, 0, 13.5),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(10.5, 2.3, 4, 9.8),
  },
  marginBottom: -theme.spacing(4),
}))

export const TopBar = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  top: 0,
  right: 0,
  position: 'absolute',
  justifyContent: 'flex-end',
  boxSizing: 'border-box',
  zIndex: 1,
  padding: theme.spacing(2.5, 5.2, 1, 26),
}))
